/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_Profile_LabelInputs */

const en_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loudness Profile`)
};

const fr_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil de loudness`)
};

const de_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautstärkeprofil`)
};

const it_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo di rumorosità`)
};

const ru_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль громкости`)
};

const es_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil de sonoridad`)
};

const zh_cn2_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响度曲线`)
};

const ja_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラウドネスプロファイル`)
};

const hi_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ध्वनि प्रोफ़ाइल`)
};

const pt_pt2_audio_description_export_loudness_profile_label = /** @type {(inputs: Audio_Description_Export_Loudness_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil de intensidade sonora`)
};

/**
* | output |
* | --- |
* | "Loudness Profile" |
*
* @param {Audio_Description_Export_Loudness_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_profile_label = /** @type {((inputs?: Audio_Description_Export_Loudness_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_profile_label(inputs)
	if (locale === "de") return de_audio_description_export_loudness_profile_label(inputs)
	if (locale === "it") return it_audio_description_export_loudness_profile_label(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_profile_label(inputs)
	if (locale === "es") return es_audio_description_export_loudness_profile_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_profile_label(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_profile_label(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_profile_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_profile_label(inputs)
	return en_audio_description_export_loudness_profile_label(inputs)
});